module.exports = __webpack_public_path__ + "static/media/fill_arrow_down.52d9b3f1.svg";